import { render, staticRenderFns } from "./ChainBPBarVoteRank.vue?vue&type=template&id=4746faf7"
import script from "./ChainBPBarVoteRank.vue?vue&type=script&lang=js"
export * from "./ChainBPBarVoteRank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports